import styled from 'styled-components';
import { Accordion, Grid, Segment } from 'semantic-ui-react';

export const StyledGridRow = styled(Grid.Row)`
padding-bottom: 5px !important;
align-items: baseline !important;
`
export const StyledGridColumns = styled(Grid.Row)`
font-weight: bold !important;
`
export const StyledAccordion = styled(Accordion)`
width: 100% !important;
margin-top: 15px;
 .title {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: black !important;
 }
`
export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
box-shadow: none !important;
padding-bottom: 20px !important;
`

export const ShowGridRow = styled(Grid.Row)`
  margin-bottom: 1rem;
  padding-bottom: 5px !important;
  align-items: baseline !important;
`;
